import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>Copyright © 2025 ErnieToTech</p>
      </div>
    </footer>
  );
};

export default Footer; 